import { collection, getDocs, query, orderBy, where } from "firebase/firestore";
import { db } from "../firebase"; // adjust the path as needed

export const fetchAvailableEvents = async () => {
  try {
    const eventsRef = collection(db, "events");
    // The `creatorUid != ""` filter is required, not cosmetic. The `events`
    // collection is shared with an analytics conversion log written by Cloud
    // Functions, and the security rules only permit a list query that
    // constrains a field unique to Event Manager events. An orderBy alone does
    // not count, so the previous query was rejected outright.
    // Firestore requires the inequality field to lead the sort.
    const eventsQuery = query(
      eventsRef,
      where("creatorUid", "!=", ""),
      orderBy("creatorUid"),
      orderBy("createdAt", "desc")
    );
    const snapshot = await getDocs(eventsQuery);

    // Map documents to event objects
    const events = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

    // For each event, fetch its content, pick a random document, and attach submissionSaleId and all content
    const eventsWithContent = await Promise.all(
      events.map(async (event) => {
        const contentRef = collection(db, "events", event.id, "content");
        const contentSnapshot = await getDocs(contentRef);

        if (!contentSnapshot.empty) {
          // Convert content documents to an array of data
          const contentDocs = contentSnapshot.docs;
          const contentData = contentDocs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));

          // Pick a random document for randomSaleId
          const randomIndex = Math.floor(Math.random() * contentDocs.length);
          const randomDoc = contentDocs[randomIndex];

          return {
            ...event,
            randomSaleId: randomDoc.data().submissionSaleId,
            content: contentData, // attach all content data
          };
        }
        // Exclude events with no content
        return null;
      })
    );

    // Filter out events without content
    return eventsWithContent.filter((event) => event !== null);
  } catch (error) {
    console.error("Error fetching events:", error);
    throw error;
  }
};
